import React from "react";

import { QUESTION_OBJECTS } from "../../../Constants/questionTypes";
import { cn } from "../../../lib/utils";

type FieldIconProps = React.HTMLAttributes<HTMLDivElement> & {
    type: string;
    index: number;
    displayIndex?: boolean;
};

export function FieldIcon({
    type,
    index,
    className,
    displayIndex = true,
    ...props
}: FieldIconProps) {
    const fieldObject = QUESTION_OBJECTS[type];
    if (!fieldObject) return null;

    const icon = fieldObject.icon;

    if (!icon) return null;

    return (
        <div
            className={cn(
                "w-fit rounded-[4px] bg-gray-100 p-2.5 flex items-center justify-center gap-1 text-xs",
                className,
            )}
            {...props}
        >
            {displayIndex && (
                <p className="text-gray-950 font-semibold">
                    {index < 10 ? `0${index}` : index}
                </p>
            )}
            {icon}
        </div>
    );
}
